import { BaseModel } from '../../../../../../core/_base/crud';

    export class ThietLapDonHangMuaModel extends BaseModel {
        Id: number
        Name: string
        IsDisable: boolean
        IsChange: boolean
        clear(){
            this.Id = 0
            this.Name = ''
            this.IsDisable = false
            this.IsChange = false
        }

        copy(item:ThietLapDonHangMuaModel){
            this.Id = item.Id
            this.Name = item.Name
            this.IsDisable = item.IsDisable
            this.IsChange = item.IsChange
        }
   
    }
